import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rootTitle: {
		id: 'software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate',
		defaultMessage: 'Quickstart',
		description: 'Initial title of Quickstart for work management projects',
	},
});
